module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/owal-logo.png"),
      "id": "logo",
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-header-area"
  }, [_c('div', {
    attrs: {
      "id": "header-text"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Owal Faces")])], 1), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
    staticClass: "separator"
  }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('router-link', {
    attrs: {
      "to": "/faces"
    }
  }, [_vm._v("Faces List")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
    staticClass: "separator"
  }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('router-link', {
    attrs: {
      "to": "/detected"
    }
  }, [_vm._v("Faces Detected")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
    staticClass: "separator"
  }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('router-link', {
    attrs: {
      "to": "/more"
    }
  }, [_vm._v("More")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "header-login"
  }, [(!_vm.isLoggedIn) ? _c('div', [_vm._v("\n      Please "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log in")])], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', [_vm._v("\n      Welcome, " + _vm._s(_vm.displayName) + "! "), _c('a', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Logout")])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24c7d49d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 296
// module chunks = 1